/* SPC — generic product page (harness design). Data comes from the page:
   variants JSON, the shop money format and the tier percentages on .hp-bsel.
   Button texts come from window.SPC_T (locale file). */
(function () {
  var T = window.SPC_T || {};
  var root = document.querySelector('[data-hp]');
  if (!root) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money, in the shop's own format ---------- */
  var moneyFormat = '€{{amount_with_comma_separator}}';
  try { moneyFormat = JSON.parse(document.querySelector('[data-hp-money]').textContent) || moneyFormat; } catch (e) {}
  function fmt(n, dec, th, ds) {
    var s = (n / 100).toFixed(dec);
    var parts = s.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return dec ? whole + ds + parts[1] : whole;
  }
  function money(cents) {
    cents = Math.round(cents);
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- Gallery ---------- */
  var track = root.querySelector('[data-hp-gal-track]');
  var slides = track ? track.querySelectorAll('[data-hp-slide]') : [];
  var thumbs = root.querySelectorAll('[data-hp-thumb]');
  var countEl = root.querySelector('[data-hp-count]');
  var current = 0;
  function mark() {
    thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === current); });
    if (countEl) countEl.textContent = current + 1;
    var active = thumbs[current];
    if (active && active.parentElement) {
      var p = active.parentElement;
      p.scrollTo({ left: active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
    }
  }
  function goTo(i) {
    if (!slides.length) return;
    current = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    mark();
  }
  if (track) {
    var gt;
    track.addEventListener('scroll', function () {
      clearTimeout(gt);
      gt = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) { current = i; mark(); }
      }, 80);
    }, { passive: true });
  }
  thumbs.forEach(function (b) { b.addEventListener('click', function () { goTo(+b.dataset.hpThumb); }); });
  var prev = root.querySelector('[data-hp-prev]'), next = root.querySelector('[data-hp-next]');
  if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
  if (next) next.addEventListener('click', function () { goTo(current + 1); });

  /* ---------- Variants ---------- */
  var variants = [];
  try { variants = JSON.parse(document.querySelector('[data-hp-variants]').textContent); } catch (e) {}
  var form = root.querySelector('[data-hp-form]');
  if (!form) return;
  var idInput = form.querySelector('[data-hp-id]');
  var qtyInput = form.querySelector('[data-hp-qty]');
  var addBtn = form.querySelector('[data-hp-add]');
  /* looked up each time: the cart drawer rebuilds the button after an add */
  function lab() { return form.querySelector('[data-hp-add-label]') || addBtn; }
  var optSteps = root.querySelectorAll('[data-hp-opt]');
  var stickyPrice = root.querySelector('[data-hp-sticky-price]');

  var qb = root.querySelector('[data-hp-qb]');
  var off = { 1: 0, 2: qb ? +qb.getAttribute('data-off-2') || 0 : 0, 3: qb ? +qb.getAttribute('data-off-3') || 0 : 0 };

  function selected() {
    return Array.prototype.map.call(optSteps, function (step) {
      var c = step.querySelector('input:checked');
      return c ? c.value : null;
    });
  }
  function optIndex(step) { return +step.dataset.hpOpt; }
  function findVariant(sel) {
    return variants.find(function (v) {
      return Array.prototype.every.call(optSteps, function (step, i) {
        return sel[i] === null || v.options[optIndex(step)] === sel[i];
      });
    });
  }
  function tier() {
    var c = root.querySelector('input[name="hp-qb"]:checked');
    return c ? +c.value : 1;
  }
  function tierTotal(v, t) { return Math.round(v.price * t * (100 - off[t]) / 100); }

  function paint(v) {
    if (!v) return;
    var t = tier();
    if (qtyInput) qtyInput.value = t;

    [1, 2, 3].forEach(function (n) {
      var now = root.querySelector('[data-hp-now="' + n + '"]');
      var was = root.querySelector('[data-hp-was="' + n + '"]');
      if (now) now.textContent = money(tierTotal(v, n));
      if (was) {
        if (n === 1) {
          var hasCompare = v.compare > v.price;
          was.hidden = !hasCompare;
          if (hasCompare) was.textContent = money(v.compare);
        } else {
          was.textContent = money(v.price * n);
        }
      }
    });

    root.querySelectorAll('.hp-offer').forEach(function (o) {
      o.classList.toggle('is-selected', +o.dataset.hpTier === t);
    });

    /* 2–3 pieces: every piece can have its own size/colour */
    var pv = pieceVariants(v, t);
    var ok = pv.every(function (x) { return x && x.available; });
    var total = ok ? Math.round(pv.reduce(function (s, x) { return s + x.price; }, 0) * (100 - off[t]) / 100) : 0;
    addBtn.disabled = !ok;
    lab().textContent = ok ? (T.add_to_cart || 'Add to cart') + ' · ' + money(total)
      : (pv.some(function (x) { return !x; }) ? (T.unavailable || 'Unavailable') : (T.sold_out || 'Sold out'));
    if (piecesBox) piecesBox.hidden = t < 2;
    pieceRows.forEach(function (row, i) { row.hidden = i >= t; });
    /* the cart drawer adds single pieces; multi-piece adds are done below */
    if (t > 1) form.setAttribute('data-cd-native', ''); else form.removeAttribute('data-cd-native');
    if (stickyPrice) stickyPrice.textContent = money(v.price);
  }

  function update() {
    var sel = selected();
    pieceRows.forEach(function (row, i) { if (i === 0 || !row.touched) setRow(row, sel); });
    optSteps.forEach(function (step, i) {
      var valEl = step.querySelector('[data-hp-optval]');
      if (valEl && sel[i]) valEl.textContent = sel[i].replace(' pet ', ' · ');
      step.querySelectorAll('.hp-size-card').forEach(function (card) {
        var inp = card.querySelector('input');
        card.classList.toggle('is-selected', !!(inp && inp.checked));
      });
    });

    var v = findVariant(sel);
    if (!v) {
      addBtn.disabled = true;
      lab().textContent = T.unavailable || 'Unavailable';
      return;
    }
    idInput.value = v.id;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState(null, '', url.toString());

    /* photo of the chosen variant, or the first photo of its colour */
    var target = -1;
    for (var i = 0; i < slides.length; i++) {
      var ids = (slides[i].dataset.variantIds || '').split(',');
      if (ids.indexOf(String(v.id)) > -1) { target = i; break; }
    }
    if (target < 0) {
      for (var j = 0; j < slides.length; j++) {
        var c = slides[j].dataset.color;
        if (c && v.options.indexOf(c) > -1) { target = j; break; }
      }
    }
    if (target > -1 && target !== current) goTo(target);

    paint(v);
  }

  /* ---------- Pieces: one row of size/colour selects per piece ----------
     Shown when 2 or 3 pieces are chosen. Row 1 is the selection above (and
     drives it); rows 2–3 start from it and can be changed one by one. */
  var piecesBox = null, pieceRows = [];
  var stepInfo = Array.prototype.map.call(optSteps, function (step) {
    var idx = optIndex(step);
    var title = step.querySelector('.hp-opt-title');
    var vals = [];
    variants.forEach(function (v) { if (vals.indexOf(v.options[idx]) < 0) vals.push(v.options[idx]); });
    return { name: title ? title.textContent.split(':')[0].trim() : '', vals: vals };
  });
  function rowSel(row) { return Array.prototype.map.call(row.querySelectorAll('select'), function (s) { return s.value; }); }
  function setRow(row, sel) { row.querySelectorAll('select').forEach(function (s, k) { if (sel[k] !== null && sel[k] !== undefined) s.value = sel[k]; }); }
  function pieceVariants(v, t) {
    var out = [], i;
    if (t < 2 || !pieceRows.length) { for (i = 0; i < t; i++) out.push(v); return out; }
    for (i = 0; i < t; i++) out.push(i === 0 ? v : findVariant(rowSel(pieceRows[i])));
    return out;
  }
  if (qb && stepInfo.length) {
    var css = document.createElement('style');
    css.textContent = '.hp-pieces{display:grid;gap:8px;margin:14px 0 6px}.hp-pieces[hidden],.hp-piece[hidden]{display:none}'
      + '.hp-piece{display:flex;align-items:center;gap:8px}.hp-piece .hp-step-badge{flex:none}'
      + '.hp-piece__sel{flex:1 1 0;min-width:0;height:44px;padding:0 10px;border:1px solid var(--line,#DCE6F2);border-radius:10px;'
      + 'background:var(--surface,#fff);color:var(--ink,#0F2137);font:inherit;font-size:.95rem}';
    document.head.appendChild(css);
    piecesBox = document.createElement('div');
    piecesBox.className = 'hp-pieces';
    piecesBox.hidden = true;
    for (var p = 1; p <= 3; p++) {
      var row = document.createElement('div');
      row.className = 'hp-piece';
      row.setAttribute('data-piece', p);
      row.hidden = true;
      row.touched = false;
      var badge = document.createElement('span');
      badge.className = 'hp-step-badge';
      badge.textContent = p;
      row.appendChild(badge);
      stepInfo.forEach(function (si, k) {
        var s = document.createElement('select');
        s.className = 'hp-piece__sel';
        s.setAttribute('aria-label', '#' + p + ' ' + si.name);
        s.setAttribute('data-k', k);
        si.vals.forEach(function (val) {
          var o = document.createElement('option');
          o.value = val;
          o.textContent = val.replace(' pet ', ' · ');
          s.appendChild(o);
        });
        row.appendChild(s);
      });
      piecesBox.appendChild(row);
      pieceRows.push(row);
    }
    qb.insertBefore(piecesBox, qb.querySelector('.hp-qb__note'));
    piecesBox.addEventListener('change', function (e) {
      var row = e.target.closest('.hp-piece');
      if (!row) return;
      if (row.getAttribute('data-piece') === '1') {
        var k = +e.target.getAttribute('data-k');
        var inp = Array.prototype.find.call(optSteps[k].querySelectorAll('input'), function (i) { return i.value === e.target.value; });
        if (inp) { inp.checked = true; update(); }
      } else {
        row.touched = true;
        paint(findVariant(selected()));
      }
    });
  }

  /* ---------- Multi-piece add: one cart line per size/colour ---------- */
  form.addEventListener('submit', function (e) {
    var t = tier();
    if (t < 2) return;
    e.preventDefault();
    var v = findVariant(selected());
    if (!v) return;
    var pv = pieceVariants(v, t);
    if (!pv.every(function (x) { return x && x.available; })) return;
    var qty = {}, order = [];
    pv.forEach(function (x) { if (!qty[x.id]) { qty[x.id] = 0; order.push(x.id); } qty[x.id] += 1; });
    var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    addBtn.disabled = true;
    lab().textContent = T.adding || 'Adding to cart…';
    fetch(root_url + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: order.map(function (id) { return { id: id, quantity: qty[id] }; }) })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || T.error || 'Error');
        return j;
      });
    }).then(function () {
      paint(findVariant(selected()));
      if (window.SPCCart) window.SPCCart.open(true); else window.location.href = root_url + 'cart';
    }).catch(function (err) {
      lab().textContent = err.message;
      setTimeout(function () { paint(findVariant(selected())); }, 2600);
    });
  });

  optSteps.forEach(function (step) { step.addEventListener('change', update); });
  root.querySelectorAll('input[name="hp-qb"]').forEach(function (r) {
    r.addEventListener('change', function () { paint(findVariant(selected())); });
  });

  update();

  /* ---------- Size guide link ---------- */
  root.querySelectorAll('[data-hp-scroll-sizes]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var d = document.getElementById('hp-sizes');
      if (d) { d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  });

  /* ---------- Buttons that lead back to the buy box ---------- */
  root.querySelectorAll('[data-hp-scrolltop]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  /* ---------- Mobile sticky bar ---------- */
  var stickyBar = root.querySelector('[data-hp-sticky]');
  if (stickyBar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      stickyBar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(addBtn);
  }
  var stickyBtn = root.querySelector('[data-hp-sticky-btn]');
  if (stickyBtn) stickyBtn.addEventListener('click', function () {
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* ---------- Reveal ---------- */
  var revealEls = root.querySelectorAll('.hp-reveal, .hp-sec, .hp-steps li');
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }
})();